<template>
  <!-- This component doesn't render anything visible, it just handles logic -->
  <div style="display: none;"></div>
</template>

<script>
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { useSubscription } from '@/composables/useSubscription';

export default {
  name: 'PaymentResultHandler',
  setup() {
    const store = useStore();
    const { refreshSubscription } = useSubscription();

    onMounted(async () => {
      const params = new URLSearchParams(window.location.search);
      const paymentStatus = params.get('payment');

      if (paymentStatus === 'success') {
        // Prevent duplicate handling using session storage
        if (!sessionStorage.getItem('payment_handled')) {
          sessionStorage.setItem('payment_handled', 'true');
          
          store.dispatch('ui/showToast', {
            message: '🎉 Your subscription is now active!',
            type: 'success'
          });
          
          await refreshSubscription();
          
          // Wait 3 seconds then redirect to dashboard if not already there
          // Or just clean URL
          setTimeout(() => {
             // Optional: redirect to dashboard
             // router.push('/dashboard'); 
          }, 3000);
        }
        
        // Clean URL query params
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);

      } else if (paymentStatus === 'cancel') {
        store.dispatch('ui/showToast', {
          message: 'Payment was cancelled.',
          type: 'info'
        });
        
        // Clean URL query params
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      }
    });

    return {};
  }
};
</script>
